export default __webpack_public_path__ + "static/media/Support.6edc8e90.svg";